import React from "react";

type ProfileImageProps = {
  color?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  borderOutlineColor?: string;
};

const CapybaraProfileSolo = ({ color, width, height, style, borderOutlineColor, ...props }: ProfileImageProps) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="-2 -2 184 184"
    width={width}
    height={height}
    style={style}
    {...props}
  >
    <defs>
      <style>
        {`
        .cls-1, .cls-2, .cls-3 {
          fill: none;
        }

        .cls-4 {
          fill: var(--jungle-art-avatar-disc, #fbffdf);
        }

        .cls-5 {
          fill: #faf6d1;
        }

        .cls-6 {
          fill: #254926;
        }

        .cls-2 {
          stroke: #522200;
          stroke-width: 2px;
        }

        .cls-2, .cls-3 {
          stroke-linecap: round;
          stroke-miterlimit: 10;
        }

        .cls-7 {
          fill: #ffce96;
        }

        .cls-8 {
          fill: #dd6800;
        }

        .cls-9 {
          fill: #ff4b75;
          isolation: isolate;
          opacity: .1;
        }

        .cls-10 {
          fill: #f7c488;
        }

        .cls-3 {
          stroke: #dd6800;
        }

        .cls-13 {
          clip-path: url(#clippath);
        }

        .cls-14 {
          fill: #522200;
        }
      `}
      </style>
      <clipPath id="clippath">
        <circle id="_x39_" className="cls-1" cx="90" cy="90" r="90" />
      </clipPath>
    </defs>
    <g id="_x37_">
      <circle
        className="cls-4"
        cx="90"
        cy="90"
        r="89"
        stroke={borderOutlineColor}
        strokeWidth={borderOutlineColor ? 1 : 0}
      />
    </g>
    <g className="cls-13">
      <g id="Capybara_-_Solo">
        <path className="cls-10" d="M116.06,47.78s4.28-23.58,13.93-21.46c9.65,2.12,16.34,18.79,17.28,31.91" />
        <path
          className="cls-7"
          d="M135.65,115.72c5.89-.26,11.84-.55,17.4-2.48,5.57-1.93,10.71-5.82,12.8-11.32,1.22-3.28,1.29-6.88,1.13-10.36-.23-4.63-.8-9.26-2.19-13.7-3.57-11.52-12.39-21.01-22.9-26.89s-22.68-8.43-34.71-8.94c-16.28-.71-33.17,2.35-46.61,11.55-13.45,9.2-22.84,25.19-21.36,41.43.74,7.98-4.15,15.25-9.75,20.94s-12.51,9.94-18.75,14.96c-9.94,7.98-18.18,17.98-24.71,28.92-3.96,6.63-7.33,13.74-8.75,21.33-1.13,5.95-1,12.06-.87,18.14.13,6.11.26,12.35,2.44,18.08,1.13,2.99,2.9,5.89,5.69,7.43,2.22,1.22,4.86,1.48,7.4,1.64,8.81.58,17.66.55,26.48-.13,17.15-1.29,33.36,6.56,50.54,6.47,20.2-.1,48.54,2.99,68.62.48,8.59-1.06,18.14-2.73,23.26-7.14,13.06-11.26,18.05-33.52,17.47-50.76-.55-16.44-18.24-47.19-30.5-61.06"
        />
        <path
          className="cls-7"
          d="M162.54,143.85c5.34-.61,10.91-.48,15.96,1.32s9.65,5.53,11.58,10.55c1.42,3.67,1.38,7.79.35,11.55-1.7,6.31-6.5,12.03-12.84,13.58-6.34,1.54-13.9-2.06-15.67-8.33l.58-28.66h.03Z"
        />
        <path
          className="cls-7"
          d="M158.94,154.52c3.6,4.02,5.34,9.43,5.92,14.8.58,5.28-.23,11.32-4.44,14.54-1.54,1.19-3.41,1.9-5.31,2.41-3.51,1-7.27,1.45-10.81.58-3.54-.87-6.82-3.35-8.01-6.76-.74-2.12-.68-4.47-.45-6.72.68-6.72,2.48-13.35,5.34-19.46,1.87-3.96,3.54-5.4,7.95-4.79,3.76.55,7.27,2.61,9.81,5.4Z"
        />
        <path
          className="cls-7"
          d="M73.37,48.42s-12.77-20.81-26.44-17.76c-13.67,3.06-12.84,30.82-10.71,35.74,2.12,4.92,4.79,10.65,4.5,14.57-.29,3.92,32.65-32.56,32.65-32.56Z"
        />
        <path
          className="cls-8"
          d="M147.94,114.56c1.74-.32,3.44-.74,5.11-1.32,5.57-1.93,10.71-5.82,12.8-11.32,1.22-3.28,1.29-6.88,1.13-10.36-.23-4.63-.8-9.26-2.19-13.7-2.28-7.4-6.76-13.96-12.45-19.27-4.44-.16-9.23-.16-12.8,2.48-3.47,2.57-4.92,7.11-5.63,11.36-1.96,11.42-.42,23.45,4.34,34.04,1.25,2.77,2.83,5.57,5.37,7.27,1.25.84.97.26,2.44.58"
        />
        <line className="cls-2" x1="145.01" y1="69.24" x2="151.44" y2="72.45" />
        <line className="cls-2" x1="158.94" y1="68.17" x2="156.78" y2="72.45" />
        <path className="cls-2" d="M154.88,73.96s2.16,17.18,0,21.97" />
        <path
          className="cls-8"
          d="M164.86,169.32c-.58-5.37-2.32-10.78-5.92-14.8h0c-.9.35-1.74.8-2.51,1.38-3.47,2.57-4.92,7.11-5.63,11.36-1.13,6.56-1.09,13.35.03,19.91,1.45-.16,2.9-.48,4.31-.87,1.9-.51,3.76-1.22,5.31-2.41,4.21-3.25,5.02-9.26,4.44-14.54l-.03-.03Z"
        />
        <path
          className="cls-8"
          d="M182.4,146.96c-1.35.39-2.61.97-3.73,1.8-3.47,2.57-4.92,7.11-5.63,11.36-1.22,7.05-1.09,14.32.29,21.3,1.7.26,3.44.19,5.08-.19,6.37-1.54,11.16-7.27,12.84-13.58,1.03-3.8,1.06-7.91-.35-11.55-1.54-3.96-4.73-7.11-8.49-9.14h0Z"
        />
        <path
          className="cls-8"
          d="M40.71,80.27c3.06-10.33,10-19.66,18.85-26.03-.39-.9-.8-1.8-1.32-2.61-3.02-4.89-8.01-8.27-13.29-10.52-1.74-.74-3.6-1.38-5.5-1.22-.64.06-1.29.19-1.9.42-3.57,9.49-2.73,22.81-1.35,26.06,1.99,4.63,4.5,10,4.5,13.9Z"
        />
        <path
          className="cls-3"
          d="M158.97,154.52c3.6,4.02,5.34,9.43,5.92,14.8.58,5.28-.23,11.32-4.44,14.54-1.54,1.19-3.41,1.9-5.31,2.41-3.51,1-7.27,1.45-10.81.58"
        />
        <path
          className="cls-14"
          d="M79,67.31c-1.67-.06-3.38.06-5.02.51-.8.23-1.64.58-2.16,1.22-.39.48-.61,1.13-.58,1.74s.32,1.22.77,1.67c.74.74,1.9.9,2.93.8,1.25-.13,2.48-.64,3.47-1.48.39-.32.74-.71.97-1.19.23-.42.32-.9.39-1.35.03-.26.1-.51.03-.77-.06-.39-.29-.77-.61-1s-.77-.29-1.16-.16"
        />
        <path
          className="cls-5"
          d="M77.39,67.53c-7.27,4.21-4.44,14.48,3.44,16.05,7.88,1.58,15.44-7.08,11.45-13.06-3.54-5.47-9.78-5.24-14.89-2.99Z"
        />
        <path
          className="cls-6"
          d="M81.73,68.21c-4.89,3.28-3.25,12.39,2.51,13.74,5.73,1.35,11.26-6.05,8.33-11.2-2.57-4.66-9.1-5.98-10.84-2.54Z"
        />
        <path
          className="cls-9"
          d="M56.09,95.6c4.47-4.05,10.74-5.53,16.76-5.69,3.73-.1,7.59.26,10.84,2.09,3.18,1.8,5.47,4.86,7.11,8.11,2.41,4.79,3.54,10.65,1.13,15.44-2.09,4.12-6.18,7.91-10.62,9.17-6.02,1.67-9.65,1.48-14.09.16-4.99-1.48-11.93-4.41-14.61-9.23-3.06-5.5-.97-16.02,3.51-20.04h-.03Z"
        />
      </g>
    </g>
  </svg>
);

export default CapybaraProfileSolo;
